var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOldfemale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 241,
    viewBox: "0 0 241 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.5 0C187.05 0 241 53.95 241 120.5C241 187.05 187.05 241 120.5 241C53.95 241 0 187.05 0 120.5C0 53.95 53.95 0 120.5 0Z",
    fill: "#F35B04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.421 170.123H58.632C58.632 170.123 45.014 173.024 42 207.422C42 207.422 78.8 235.21 116 237C160.175 239.125 200 207.422 200 207.422L195.842 182.556C195.842 182.556 193.867 169.708 175.053 170.123L148.026 168.051L79.421 170.123Z",
    fill: "#99C7E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.367 143.184V161.834C104.367 161.834 99.4823 171.366 79.4203 170.123C79.4203 170.123 73.2873 197.476 110.604 203.278C110.604 203.278 159.771 215.297 162.578 170.123C162.578 170.123 141.061 170.537 137.631 161.834L139.71 143.184H104.367Z",
    fill: "#FFE1D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.367 143.184C104.367 143.184 93.6612 158.587 83.5782 145.256C83.5782 145.256 74.9502 146.845 69.0252 141.112C69.0252 141.112 82.2272 130.267 75.2622 118.318L66.9462 103.812C66.9462 103.812 64.2092 86.7511 71.1042 76.8741C71.1042 76.8741 79.1082 72.2461 79.4202 66.5131C79.4202 66.5131 80.1482 29.0751 120.999 33.3571C120.999 33.3571 152.218 29.4201 162.578 47.8631C162.578 47.8631 161.92 66.0291 168.815 70.6571C168.815 70.6571 187.213 87.0961 172.973 112.101C172.973 112.101 160.187 131.649 179.21 139.04C179.21 139.04 181.323 149.608 164.657 145.256C164.657 145.256 162.89 157.62 148.025 147.328C148.025 147.328 145.842 155.548 141.788 147.328C137.735 139.109 129.315 151.473 129.315 151.473L114.762 147.328L104.367 143.184Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.342 72.7291C156.342 72.7291 151.526 57.0491 123.079 56.1521L104.368 49.9351L89.816 60.2961L85.658 68.5851V81.0181L87.737 91.3791C87.737 91.3791 72.526 102.293 87.737 112.101V124.534C87.737 124.534 100.245 147.881 114.763 151.473C114.763 151.473 124.846 160.66 133.474 149.401C133.474 149.401 152.219 136.139 154.263 126.606C154.263 124.88 156.342 114.173 156.342 114.173C156.342 114.173 174.741 103.674 156.342 91.3791V72.7291Z",
    fill: "#FFE1D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOldfemale);
export default __webpack_public_path__ + "static/media/oldfemale.55f2c2c2e506ce2981b48d7ced4b1a35.svg";
export { ForwardRef as ReactComponent };